import { usePropertyStreet2 } from '../../../../../queries/usePropertyCoreFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PropertyAddressStreet2Props {
    propertyGuid: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressStreet2: React.FC<PropertyAddressStreet2Props> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'Street Address (cont.)';
    const [propertyAddressStreet2, set_propertyAddressStreet2] = usePropertyStreet2(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressStreet2}
                />
            ) : (
                <TextBox
                    id='propertyAddressLine2'
                    value={propertyAddressStreet2}
                    onChange={(value) => set_propertyAddressStreet2(value)}
                    label={label}
                    placeholder='Suite 123'
                    required={required}
                    width='100%'
                    readOnly={readOnly}
                    maxLength={50}
                    validator={validator}
                />
            )}
        </>
    );
};
